var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20C16.0229 20 20.5 15.5229 20.5 10C20.5 4.47715 16.0229 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5229 4.97715 20 10.5 20ZM15.8708 6.83545C16.0561 6.6307 16.0402 6.3145 15.8354 6.12925C15.6307 5.94395 15.3145 5.95975 15.1292 6.16455L9.14045 12.7837L5.84525 9.6383C5.6455 9.44765 5.329 9.455 5.1383 9.65475C4.94765 9.8545 4.955 10.171 5.15475 10.3617L8.82145 13.8617L9.1929 14.2162L9.53745 13.8355L15.8708 6.83545Z",
    fill: "#1E972A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/GreenTick.f54e7ba3209b8de610cd9366125a5b91.svg";
export { ForwardRef as ReactComponent };